module.exports = __webpack_public_path__ + "static/media/LINK.4b02bc11.svg";